"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _fuseUtils = require("@tvg/fuse-utils");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _styledBaseinput = require("./styled-baseinput");
var _excluded = ["children", "name", "analyticsId", "className", "errorMessageId", "isChecked", "isDisabled", "isError", "onChange", "value", "componentId"];
function _interopRequireDefault(e) {
  return e && e.__esModule ? e : {
    "default": e
  };
}
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest();
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}
function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}
function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}
function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}
var memo = _react["default"].memo,
  useState = _react["default"].useState,
  useCallback = _react["default"].useCallback,
  useMemo = _react["default"].useMemo,
  useEffect = _react["default"].useEffect;
var propTypes = {
  children: _propTypes["default"].oneOfType([_propTypes["default"].arrayOf(_propTypes["default"].node), _propTypes["default"].node]).isRequired,
  name: _propTypes["default"].string.isRequired,
  analyticsId: _propTypes["default"].string,
  className: _propTypes["default"].string,
  errorMessageId: _propTypes["default"].string,
  isChecked: _propTypes["default"].bool,
  isDisabled: _propTypes["default"].bool,
  isError: _propTypes["default"].bool,
  onChange: _propTypes["default"].func,
  value: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  componentId: _propTypes["default"].string
};
var defaultProps = {
  analyticsId: '',
  className: '',
  errorMessageId: undefined,
  isChecked: false,
  isDisabled: false,
  isError: false,
  onChange: null,
  value: '',
  componentId: (0, _fuseUtils.uuid)()
};
function BaseInput(_ref) {
  var children = _ref.children,
    name = _ref.name,
    analyticsId = _ref.analyticsId,
    className = _ref.className,
    errorMessageId = _ref.errorMessageId,
    isChecked = _ref.isChecked,
    isDisabled = _ref.isDisabled,
    isError = _ref.isError,
    onChange = _ref.onChange,
    value = _ref.value,
    componentId = _ref.componentId,
    others = _objectWithoutProperties(_ref, _excluded);
  var _useState = useState(!!isChecked),
    _useState2 = _slicedToArray(_useState, 2),
    checked = _useState2[0],
    setChecked = _useState2[1];
  var id = useMemo(function () {
    return "".concat(name, "_").concat(componentId);
  }, [name, componentId]);
  var handleChange = useCallback(function (event) {
    var _event$target;
    setChecked(event === null || event === void 0 || (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.checked);
    if (typeof onChange === 'function') onChange(event);
  }, [onChange]);
  useEffect(function () {
    setChecked(isChecked);
  }, [isChecked]);
  return /*#__PURE__*/_react["default"].createElement(_styledBaseinput.StyledCheckbox, null, /*#__PURE__*/_react["default"].createElement(_styledBaseinput.StyledInput, _extends({
    name: name,
    "aria-describedby": errorMessageId || undefined,
    "data-analyticsid": analyticsId,
    checked: checked,
    className: className,
    disabled: !!isDisabled,
    id: id,
    onChange: handleChange,
    type: "checkbox",
    value: value
  }, others)), /*#__PURE__*/_react["default"].createElement(_styledBaseinput.StyledLabel, {
    "aria-invalid": isError || undefined,
    htmlFor: id
  }, /*#__PURE__*/_react["default"].createElement(_styledBaseinput.StyledLabelTappableArea, null, children)));
}
BaseInput.propTypes = propTypes;
BaseInput.defaultProps = defaultProps;
var _default = exports["default"] = memo(BaseInput);